import * as React from 'react';
import Auftraege from './Auftraege';

export default class AuftragUebersichtEigene extends React.Component<{}, {}> {
  render() {
    return (
      <div>
        <h2>
          Meine Aufträge
        </h2>
        <Auftraege lizenzAuftraege={false}/>
      </div>);
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/auftraege/AuftragUebersichtEigene.tsx